export const FACEBOOK_SHARE_URL_PREFIX = "https://www.facebook.com/sharer/sharer.php?u=";
export const TWITTER_SHARE_URL_PREFIX = "https://twitter.com/share?url=";
export const LINKEDIN_SHARE_URL_PREFIX = "http://www.linkedin.com/shareArticle?mini=true&url=";
